export const T = {
  en_GB: {
    failedToLoad: "Failed to load dynamic portfolios.",
  },
  nb_NO: {
    failedToLoad: "Kunne ikke laste dynamiske porteføljer.",
  },
} as const;
